const SETTINGS = {
    HOME: "https://agroecologiaemrede.org.br",
    MAPBOX_ACCESS_TOKEN: "pk.eyJ1IjoiZHR5Z2VsIiwiYSI6IjY4YjRhNjU1NWJhYTU2OGU1YWQ1OTcxYjRjNDcyNzIxIn0.Go-whnL9yIt3rHicQ5gqbA"
};

export default SETTINGS;

